import styled from 'styled-components'
import { Layout } from 'antd'
import theme from '../../styles/theme'
import { Content } from 'antd/es/layout/layout'

export const LayoutWrapper = styled.div`
  .ant-layout {
    display: flex;
  }

  .ant-layout-has-sider {
    flex-direction: row;
  }
`

export const StyledLayout = styled(Layout)`
  background-color: ${theme.colors.white};
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const StyledContent = styled(Content)`
  padding: 0;
  margin: 0;
  min-height: 280px;
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const ContentWrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${theme.colors.white};

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Copyright = styled.div`
  color: ${({ theme }) => theme.colors.grayDark};
  padding: 20px;
`

export const TableFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  padding: 8px;

  .ant-select-dropdown {
    top: auto !important;
    bottom: 100% !important;
    transform: unset !important;
  }

  @media (max-width: 768px) {
    .ant-pagination {
      .ant-pagination-item,
      .ant-pagination-prev,
      .ant-pagination-next {
        min-width: 44px;
        height: 44px;
        line-height: 42px;
        font-size: 16px;
        border-radius: 8px;
      }
      .ant-pagination-item a {
        line-height: 42px;
      }
      .ant-pagination-prev .ant-pagination-item-link,
      .ant-pagination-next .ant-pagination-item-link {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        font-size: 18px;
      }
      .ant-pagination-options {
        .ant-select-selector {
          height: 44px;
          padding: 0 12px;
          font-size: 16px;
          .ant-select-selection-item {
            line-height: 42px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 0;

    .ant-pagination {
      margin-bottom: 12px;
      flex-wrap: nowrap;
    }
  }
`

export const TableFooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TableFooterCenter = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`

export const TableFooterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 14px;
`
export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: stretch;
`

interface MenuHeaderProps {
  isCollapsed?: boolean
}

export const MenuHeader = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'isCollapsed',
})<MenuHeaderProps>`
  padding: 20px;
  display: flex;
  justify-content: end;

  ${({ isCollapsed }) =>
    isCollapsed &&
    `
      .logo-mini-icon {
        width: 0;
        padding: 0;
      }
      .sidebar-icon {
        flex: 1;
        text-align: center
      }
    `}
`

export const UserProfileMenuWrapper = styled.div`
  width: 296px;
  max-width: calc(100vw - 32px);
  padding: 12px;

  .profile-menu-identity {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 8px 12px;
  }

  .profile-menu-avatar {
    flex: none;
    background: #52c41a;
    font-size: 14px;
  }

  .profile-menu-details {
    min-width: 0;
  }

  .profile-menu-name,
  .profile-menu-office {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .profile-menu-name {
    color: #202735;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
  }

  .profile-menu-office {
    color: #747e97;
    font-size: 12px;
    line-height: 18px;
  }

  .profile-menu-action {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-height: 44px;
    padding: 0 10px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #202735;
    font: inherit;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #f3f5f9;
    }

    &:focus-visible {
      outline: 2px solid var(--system-focus, #606a91);
      outline-offset: 2px;
    }

    svg {
      width: 18px;
      height: 18px;
      color: #38496c;
    }
  }
`

export const OrganizationLogoWrapper = styled.span`
  display: flex;
  color: #fff;
  padding: 0;
  margin: 0;
  flex-direction: row;
  justify-content: center;
  background-color: #ffffff;
`
